// @flow
import * as React from 'react';

import { selectIsAuthenticatedUser } from '@gandi/authentication';
import {
  selectCartCurrency,
  selectCartIsCommitted,
  selectCartUUID,
} from '@gandi/cart';
import type { DecoratedProduct } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';

import { useAppSelector } from 'src/hooks/useAppSelector';

// eslint-disable-next-line import/no-cycle
import { getProductComponent } from '../../tools';

type Props = {
  option: DecoratedProduct,
};

export default function Option({ option }: Props): React.Node {
  const translator = useTranslator();
  const cartCommitted = useAppSelector(selectCartIsCommitted);
  const authenticated = useAppSelector(selectIsAuthenticatedUser);
  const currency = useAppSelector(selectCartCurrency);
  const cartId = useAppSelector(selectCartUUID);

  const componentName =
    option.productType === 'mailboxv2' && option.process === 'renew'
      ? ('MailboxOptionRenew' as const)
      : option.component;

  const Renderer = getProductComponent(componentName);

  return (
    <Renderer
      translator={translator}
      cartCommitted={cartCommitted}
      authenticated={authenticated}
      currency={currency}
      cartId={cartId}
      product={option}
    />
  );
}
